module.exports = __webpack_public_path__ + "static/media/hockey.a891bc9a.webp";